import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HotelPartnershipsSlide } from './HotelPartnershipsSlide';
import { BrandPartnershipsSlide } from './BrandPartnershipsSlide';
import { ContentShowcaseSlide } from './ContentShowcaseSlide';
import { StorytellingSlide } from './StorytellingSlide';
import { ResultsSlide } from './ResultsSlide';
import { SocialMediaVideosSlide } from './SocialMediaVideosSlide';
export function ClientDeckPage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    id: 'intro',
    title: 'explorandoconfran',
    subtitle: 'Propuesta de Colaboración',
    content: <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-583">
          <div className="w-full md:w-1/2" data-id="element-584">
            <p className="text-base md:text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-585">
              Gracias por considerar esta propuesta. A continuación encontrarás
              una visión general de cómo podemos trabajar juntos para crear
              experiencias auténticas que conecten con audiencias activas y
              apasionadas por la naturaleza.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-586">
              Este deck presenta mi enfoque, alcance y las formas en que tu
              marca puede ser parte de un viaje que{' '}
              <span className="font-medium" data-id="element-587">inspira afuera y adentro</span>.
            </p>
          </div>
          <div className="w-full md:w-1/2" data-id="element-588">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jt4rCsvChGhB3sYBjCMymS/Untitled_design_-_2025-06-19T233717.679.png" alt="Fran explorando en las montañas" className="w-full h-auto rounded-lg shadow-md" data-id="element-589" />
          </div>
        </div>
  }, {
    id: 'audience',
    title: 'Audiencia y Alcance',
    subtitle: 'Quiénes nos acompañan en este viaje',
    content: <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-590">
          <div className="bg-gray-50 p-6 rounded-lg" data-id="element-591">
            <h3 className="text-xl font-normal text-black mb-4 flex items-center" data-id="element-592">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/if4RacDtbfddqkvrotpJLk/tiktok-logo-thin.svg" alt="TikTok logo" className="h-5 w-5 mr-2" data-id="element-593" />
              TikTok
            </h3>
            <div className="grid grid-cols-2 gap-6 mb-4" data-id="element-594">
              <div data-id="element-595">
                <p className="text-3xl font-normal text-black mb-1" data-id="element-596">10K</p>
                <p className="text-sm text-gray-600" data-id="element-597">Seguidores</p>
              </div>
              <div data-id="element-598">
                <p className="text-3xl font-normal text-black mb-1" data-id="element-599">
                  <span className="font-medium" data-id="element-600">299K</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-601">
                  Visualizaciones (60 días)
                </p>
              </div>
            </div>
            <p className="text-sm text-gray-700" data-id="element-602">
              <span className="font-medium" data-id="element-603">69% mujeres</span> •{' '}
              <span className="font-medium" data-id="element-604">25-34 años</span> •{' '}
              <span className="font-medium" data-id="element-605">91.6% México</span>
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg" data-id="element-606">
            <h3 className="text-xl font-normal text-black mb-4 flex items-center" data-id="element-607">
              <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-608">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-609"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-610"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-611"></line>
              </svg>
              Instagram
            </h3>
            <div className="grid grid-cols-2 gap-6 mb-4" data-id="element-612">
              <div data-id="element-613">
                <p className="text-3xl font-normal text-black mb-1" data-id="element-614">7.6K</p>
                <p className="text-sm text-gray-600" data-id="element-615">Seguidores</p>
              </div>
              <div data-id="element-616">
                <p className="text-3xl font-normal text-black mb-1" data-id="element-617">
                  <span className="font-medium" data-id="element-618">127K</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-619">
                  Visualizaciones (90 días)
                </p>
              </div>
            </div>
            <p className="text-sm text-gray-700" data-id="element-620">
              <span className="font-medium" data-id="element-621">50.7% hombres</span> •{' '}
              <span className="font-medium" data-id="element-622">25-34 años</span> •{' '}
              <span className="font-medium" data-id="element-623">88.3% México</span>
            </p>
          </div>
        </div>
  }, {
    id: 'social-media-videos',
    title: 'Mis Videos',
    subtitle: 'Contenido en redes sociales',
    content: <SocialMediaVideosSlide data-id="element-624" />
  }, {
    id: 'hotel-partnerships',
    title: 'Colaboraciones con Hoteles',
    subtitle: 'Destinos y experiencias',
    content: <HotelPartnershipsSlide data-id="element-625" />
  }, {
    id: 'brand-partnerships',
    title: 'Marcas Asociadas',
    subtitle: 'Colaboraciones y alianzas',
    content: <BrandPartnershipsSlide data-id="element-626" />
  }, {
    id: 'content-showcase',
    title: 'Contenido Destacado',
    subtitle: 'Creaciones que inspiran',
    content: <ContentShowcaseSlide data-id="element-627" />
  }, {
    id: 'storytelling',
    title: 'Narrativa Visual',
    subtitle: 'Historias que conectan',
    content: <StorytellingSlide data-id="element-628" />
  }, {
    id: 'results',
    title: 'Resultados e Impacto',
    subtitle: 'El valor de la colaboración',
    content: <ResultsSlide data-id="element-629" />
  }, {
    id: 'services',
    title: 'Servicios Propuestos',
    subtitle: 'Cómo podemos colaborar',
    content: <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-630">
          <div className="bg-white p-6 rounded-lg shadow-sm border-t-2 border-black" data-id="element-631">
            <h3 className="text-lg font-medium text-black mb-2" data-id="element-632">
              Cobertura de Eventos
            </h3>
            <p className="text-sm text-gray-600 mb-4" data-id="element-633">Desde 12,000 MXN</p>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed" data-id="element-634">
              Documentación completa de tu evento con fotografías, videos cortos
              y contenido para redes sociales.
            </p>
            <ul className="space-y-2 mb-4" data-id="element-635">
              <li className="text-sm text-gray-700 flex items-start" data-id="element-636">
                <span className="mr-2 text-black" data-id="element-637">—</span>
                Historias en tiempo real
              </li>
              <li className="text-sm text-gray-700 flex items-start" data-id="element-638">
                <span className="mr-2 text-black" data-id="element-639">—</span>
                Publicación destacada
              </li>
              <li className="text-sm text-gray-700 flex items-start" data-id="element-640">
                <span className="mr-2 text-black" data-id="element-641">—</span>
                30 imágenes editadas
              </li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border-t-2 border-black" data-id="element-642">
            <h3 className="text-lg font-medium text-black mb-2" data-id="element-643">
              Embajador de Marca
            </h3>
            <p className="text-sm text-gray-600 mb-4" data-id="element-644">Desde 15,000 MXN</p>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed" data-id="element-645">
              Tu marca viaja conmigo, apareciendo de forma natural en aventuras
              y reflexiones.
            </p>
            <ul className="space-y-2 mb-4" data-id="element-646">
              <li className="text-sm text-gray-700 flex items-start" data-id="element-647">
                <span className="mr-2 text-black" data-id="element-648">—</span>2 publicaciones
                mensuales
              </li>
              <li className="text-sm text-gray-700 flex items-start" data-id="element-649">
                <span className="mr-2 text-black" data-id="element-650">—</span>4 historias mensuales
              </li>
              <li className="text-sm text-gray-700 flex items-start" data-id="element-651">
                <span className="mr-2 text-black" data-id="element-652">—</span>
                Reporte mensual de alcance
              </li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border-t-2 border-black" data-id="element-653">
            <h3 className="text-lg font-medium text-black mb-2" data-id="element-654">
              Campañas 360°
            </h3>
            <p className="text-sm text-gray-600 mb-4" data-id="element-655">Desde 20,000 MXN</p>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed" data-id="element-656">
              Campaña completa diseñada como un viaje transformador para tu
              marca.
            </p>
            <ul className="space-y-2 mb-4" data-id="element-657">
              <li className="text-sm text-gray-700 flex items-start" data-id="element-658">
                <span className="mr-2 text-black" data-id="element-659">—</span>
                Estrategia completa de contenido
              </li>
              <li className="text-sm text-gray-700 flex items-start" data-id="element-660">
                <span className="mr-2 text-black" data-id="element-661">—</span>
                Video promocional narrativo
              </li>
              <li className="text-sm text-gray-700 flex items-start" data-id="element-662">
                <span className="mr-2 text-black" data-id="element-663">—</span>
                Contenido para tus plataformas
              </li>
            </ul>
          </div>
        </div>
  }, {
    id: 'contact',
    title: 'Hablemos',
    subtitle: 'Construyamos juntos tu próxima aventura',
    content: <div className="flex flex-col items-center text-center max-w-2xl mx-auto" data-id="element-664">
          <p className="text-base text-gray-700 mb-8 leading-relaxed" data-id="element-665">
            Estoy emocionado por la posibilidad de colaborar contigo. Cada
            proyecto es único y me encantaría discutir cómo podemos adaptar mis
            servicios a tus necesidades específicas.
          </p>
          <div className="flex flex-col items-center mb-8" data-id="element-666">
            <p className="text-base font-medium text-black mb-1" data-id="element-667">
              Contáctame directamente
            </p>
            <a href="mailto:contacto@explorandoconfran.com" className="text-base text-gray-700 hover:text-black transition-colors" data-id="element-668">
              contacto@explorandoconfran.com
            </a>
            <a href="https://wa.me/16462819972" className="text-base text-gray-700 hover:text-black transition-colors" data-id="element-669">
              +52 123 456 789
            </a>
          </div>
          <a href="https://wa.me/16462819972" className="bg-black text-white px-10 py-4 text-sm uppercase rounded-full hover:bg-gray-800 transition-colors font-medium tracking-wider" data-id="element-670">
            AGENDAR UNA LLAMADA
          </a>
        </div>
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => prev === slides.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? slides.length - 1 : prev - 1);
  };
  const goToSlide = index => {
    setCurrentSlide(index);
  };
  return <div className="w-full min-h-screen bg-white pt-24 pb-12" data-id="element-671">
      <div className="container mx-auto px-6" data-id="element-672">
        <div className="max-w-5xl mx-auto" data-id="element-673">
          {/* Navigation */}
          <div className="mb-12 flex justify-between items-center" data-id="element-674">
            <Link to="/" className="text-black hover:text-gray-700 transition-colors" data-id="element-675">
              ← Volver
            </Link>
            <div className="flex space-x-2" data-id="element-676">
              {slides.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-3 h-3 rounded-full ${currentSlide === index ? 'bg-black' : 'bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-677" />)}
            </div>
          </div>
          {/* Current Slide */}
          <div className="mb-12" data-id="element-678">
            <h1 className="text-3xl md:text-4xl font-normal text-black mb-2" data-id="element-679">
              {slides[currentSlide].title}
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-10" data-id="element-680">
              {slides[currentSlide].subtitle}
            </p>
            <div className="slide-content" data-id="element-681">{slides[currentSlide].content}</div>
          </div>
          {/* Controls */}
          <div className="flex justify-between" data-id="element-682">
            <button onClick={prevSlide} className="px-6 py-2 border border-gray-300 rounded hover:bg-gray-50 transition-colors" data-id="element-683">
              Anterior
            </button>
            <button onClick={nextSlide} className="px-6 py-2 bg-black text-white rounded hover:bg-gray-800 transition-colors" data-id="element-684">
              Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>;
}